module.exports = __webpack_public_path__ + "media/loading.511d9a00.mp3";